<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				
				<el-form-item>
					<el-input v-model="filters.sites" placeholder="站点" @keyup.enter.native="getLists"></el-input>
				</el-form-item>
				<el-form-item>
					<el-select 
						v-model="filters.scode" filterable placeholder="选择上游" class="h-m-select">
					  <el-option v-for="item in splist"
						:key="item.scode" :label="item.sname" v-model="item.scode">
					  </el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="filters.status" placeholder="请选择状态">
						<el-option label="正常" value="1"></el-option>
						<el-option label="未分配" value="2"></el-option>
						<el-option label="下线" value="3"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="getLists">搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<!--列表-->
		<el-table :data="datalist" border stripe highlight-current-row v-loading="listLoading" style="width:90%;" height="600">
			<el-table-column prop="entime" label="时间" min-width="100"></el-table-column>
			<el-table-column prop="spname" label="上游" min-width="100"></el-table-column>
			<el-table-column prop="cpname" label="渠道" min-width="100"></el-table-column>
			<el-table-column prop="site" label="sites" min-width="100"></el-table-column>
			<el-table-column prop="status" label="状态" min-width="100">
				<template slot-scope="scope"><span v-html="formateStatus(scope.row)"></span></template>
			</el-table-column>
			<el-table-column label="操作" fixed="right" width="100">
				<template slot-scope="scope">
					<div>
						<el-button type="text" size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
						<el-button type="text" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<!--工具条翻页-->
		<el-col :span="24" class="toolbar">
		<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="pagesize" :total="total" style="float:right;"></el-pagination>
		</el-col>

		<!--编辑界面-->
		<el-dialog :title="editformtitle" :visible.sync="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="100px" :rules="formRules" ref="editForm">
				<el-form-item label="Site" prop="sites">
					<el-input v-model="editForm.sites" placeholder="编号"></el-input>
				</el-form-item>
				<el-form-item label="上游" prop="scode">
					<el-select 
						v-model="editForm.scode" filterable placeholder="请输入/请选择" class="h-m-select">
					  <el-option v-for="item in splist"
						:key="item.scode" :label="item.sname" v-model="item.scode">
					  </el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="状态" class="is-required">
					<el-select v-model="editForm.status" placeholder="请选择状态">
						<el-option label="正常" value="1"></el-option>
						<el-option label="未分配" value="2"></el-option>
						<el-option label="下线" value="3"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>
<script>
	import util from '../../common/js/util'
	import { getListPage, delData, saveData } from '../../api/api';
	export default {
		data() {
			return {
				filters:{
					scode:'',sites:'',status:''
				},
				datalist: [],
				splist:[],
				total: 0,
				pagesize:20,
				page: 1,
				listLoading: false,
				/////////////Form 表单
				editformtitle:'',//form编辑名称
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				formRules: {
					scode :[
						{required: true,message: '编号不能为空!',trigger: 'blur'}
					],
					sites :[
						{required: true,message: '名称不能为空!',trigger: 'blur'}
					],
				},
				//编辑界面数据
				editForm: {
					actionurl:'',sqlid:'',entime:'',scode:'',sites:'',status:''
				}
			}
		},
		methods: {
			handleCurrentChange(val) {
				this.page = val;
				this.getLists();
			},
			formateStatus: function (row, column) {
				if(row.status == 1) return (`<span style="color:#4CAF50">正常</span>`);
				if(row.status == 2) return (`<span style="color:#FF9800">未分配</span>`);
				return (`<span style="color:#E91E63">下线</span>`);
			},
			getSpList(){
				let para = {
					actionurl:'default/getListAll',
					sqlid:'html_spinfo.query',
				};
				getListPage(para).then((res) => {
					if(res.data.status==-200){
						this.$message({
							message: res.data.message,
							type: res.data.type
						});
					}else{
						this.splist = res.data.datas;
					}
				});
				
			},
			getLists:function(){
				let para = {
					page: this.page,
					pagesize:this.pagesize,
					actionurl:'default/getList',
					scode:this.filters.scode,
					sites:this.filters.sites,
					status:this.filters.status,
					sqlid:'html_sites.query'
				};
				this.listLoading = true;
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.total = res.data.total;
						this.datalist = res.data.datas;
					}
					this.listLoading = false;
				});
			},
			handleAdd:function(){
				this.editFormVisible = true;
				this.editformtitle = '新增';
				this.editForm = {
					actionurl:'default/save',sqlid:'html_sites.add',entime:'',scode:'',sites:'',status:'1'
				};
			},
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editformtitle = '编辑';
				this.editForm = Object.assign({}, row);
				this.editForm.actionurl = 'default/save';//设置Sqlid
				this.editForm.sqlid = 'html_sites.upt';
			},
			editSubmit:function(){
				let para = Object.assign({}, this.editForm);
				util.saveFunction(this,para);
			},
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {type: 'warning'}).then(() => {
					this.listLoading = true;
					let para = {
						actionurl:'default/del',
						sqlid:'html_sites.del',
						id:row.id
					};
					delData(para).then((res) => {
						this.listLoading = false;
						this.$message({message: res.data.message,type: res.data.type});
						this.getLists();
					});
				}).catch(() => {});
			}
		},
		mounted() {
			this.getSpList();
			this.getLists();
		}
	}	
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// siteList.vue?3ce5119e